import { useEffect, useState } from 'react';
import {
  createDailyCheck,
  getDailyCheckId,
  getServerRefreshTimestamp,
  getSortedCollection,
} from '../services/firestore';

export function useStaticData() {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleReloadData = async () => {
    const timestamp = Math.floor(Date.now() / 1000);

    if (getLocalStorage('latestRefresh') + 3600 >= timestamp) return null;
    setLoading(true);
    localStorage.removeItem('aircraft');
    localStorage.removeItem('documents');
    localStorage.removeItem('tasks');
    getData().then(() => setLoading(false));
    setLocalStorage('latestRefresh', timestamp);
    window.location.reload(false);
  };

  const getLocalStorage = (item) => {
    return JSON.parse(localStorage.getItem(item));
  };

  const setLocalStorage = (item, data) => {
    localStorage.setItem(item, JSON.stringify(data));
  };

  async function getData() {
    setTimeout(async () => {
      const docId = await getDailyCheckId();
      if (!docId) createDailyCheck();
    }, 5000);
    const aircraftData = await getSortedCollection('aircraft');
    const documentData = await getSortedCollection('documents');
    const taskData = await getSortedCollection('tasks');

    // const localAircraftData = getLocalStorage('aircraft');
    // const localDocumentData = getLocalStorage('documents');
    // const localTaskData = getLocalStorage('tasks');

    setLocalStorage('aircraft', aircraftData);
    setLocalStorage('documents', documentData);
    setLocalStorage('tasks', taskData);
  }

  useEffect(() => {
    if (initialized) {
      setLoading(false);
      return;
    }
    const initDataInterval = setInterval(async () => {
      const localAircraftData = getLocalStorage('aircraft');
      const localDocumentData = getLocalStorage('documents');
      const localTaskData = getLocalStorage('tasks');

      const localRefreshTimestamp = getLocalStorage('latestRefresh');
      const serverRefreshTimestamp = await getServerRefreshTimestamp();
      const serverRequiresUpdate =
        serverRefreshTimestamp && serverRefreshTimestamp > localRefreshTimestamp;

      if (
        !initialized &&
        (!localAircraftData ||
          !localDocumentData ||
          !localTaskData ||
          !localRefreshTimestamp ||
          serverRequiresUpdate)
      ) {
        getData().then(() => {
          setLoading(false);
          setInitialized(true);
          setLocalStorage('latestRefresh', serverRefreshTimestamp);
        });
      } else {
        setLoading(false);
        clearInterval(initDataInterval);
      }
    }, 1000);

    return () => clearInterval(initDataInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized]);

  return { loading, handleReloadData };
}
